import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatVolume } from './WhaleTradesPanel';

function ExchangeVolumePanel({ exchangeVolumes, hours }) {
  const { t } = useTranslation();
  // Sort exchanges by volume descending, take top 5
  const entries = exchangeVolumes
    ? Object.entries(exchangeVolumes)
        .map(([name, data]) => ({ name, volume: data.volume, count: data.count }))
        .sort((a, b) => b.volume - a.volume)
        .slice(0, 5)
    : [];

  const maxVolume = entries.length > 0 ? entries[0].volume : 1;
  const totalVolume = entries.reduce((sum, e) => sum + e.volume, 0);

  return (
    <div className="stats-panel stats-vol-panel">
      <div className="stats-panel-header">
        <span className="stats-panel-title">{t('stats.exchangeVolume')}</span>
      </div>

      {entries.length === 0 ? (
        <div className="stats-vol-empty">{t('stats.noExchangeData')}</div>
      ) : (
        <>
          <div className="stats-vol-grid">
            {entries.map((ex) => {
              const pct = (ex.volume / maxVolume) * 100;
              return (
                <div key={ex.name} className="stats-vc">
                  <div className="stats-vtrack">
                    <div
                      className="stats-vfill"
                      style={{ height: `${pct}%` }}
                    />
                  </div>
                  <div className="stats-vc-label">{formatExchangeName(ex.name)}</div>
                  <div className="stats-vc-value">{formatVolume(ex.volume)}</div>
                </div>
              );
            })}
          </div>
          <div className="stats-vol-total">
            <span className="stats-vol-total-lbl">{t('stats.hTotal', { hours: hours || 24 })}</span>
            <span className="stats-vol-total-val">{formatVolume(totalVolume)}</span>
          </div>
        </>
      )}
    </div>
  );
}

function formatExchangeName(name) {
  if (!name) return '?';
  // Shorten common exchange names
  const short = name
    .replace(/_FUTURES$/i, '')
    .replace(/_PERP$/i, '')
    .replace(/_SWAP$/i, '');
  // Capitalize first letter, lowercase rest
  return short.charAt(0).toUpperCase() + short.slice(1).toLowerCase();
}

export { formatExchangeName };
export default ExchangeVolumePanel;
